import styled from 'styled-components';

import { spaceS, spaceXS } from '@xingternal/tokens';
import { Headline as HeadlineComponent } from '@xingternal/typography';

export const Wrapper = styled.div`
  width: 100%;
  margin-bottom: ${spaceXS};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Headline = styled(HeadlineComponent)`
  margin-bottom: 0;
  margin-right: ${spaceS};
`;
